<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" align="center">
        <v-row justify="center">
          <v-col>
            <v-select v-model="selected"
                      dense
                      outlined
                      background-color="grey"
                      rounded
                      :items="tags"
                      @input="changeUser"
            />
          </v-col>
          <v-col>
            <v-select
              v-model="selectedLanguages"
              dense
              outlined
              background-color="grey"
              rounded
              :items="languages"
              @input="changeUser"
            />
          </v-col>
        </v-row>
        <h5 style="text-align: left">
          Text
        </h5>
        <v-text-field
          v-model="text"
          required
          name="text"
          type="text"
          outlined
          readonly
        />
        <h5 style="text-align: left">
          Text Extra
        </h5>
        <v-text-field
          v-model="textExtra"
          required
          name="text"
          type="text"
          outlined
          readonly
        />
        <h5 style="text-align: left">
          Video Url
        </h5>
        <v-text-field
          v-model="videoURL"
          required
          name="videoURL"
          type="text"
          outlined
        />
        <h5 style="text-align: left">
          link
        </h5>
        <v-text-field
          v-model="link"
          required
          name="link"
          type="text"
          outlined
        />   
        <h5 style="text-align: left">
          Description Link
        </h5>
        <v-text-field
          v-model="descriptionLink"
          required
          name="descriptionLink"
          type="text"
          outlined
        />
      </v-col>
      <v-btn @click="saveTag">
        SAVE
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import ApiRepository from "@/repositories/ApiRepository";

export default {
    name: "EditableSystemMessages",
    props: {
        id: {type: String, default: "Video Upload"}
    },
    data () {
        return {
            text: '',
            textExtra:'',
            videoURL: '',
            link: '',
            descriptionLink: '', 
            languages: ['ca', 'es', 'en'],
            tags: [],
            selected: 0,
            selectedLanguages: '',
        };
    },
    created () {
        this.selectedLanguages = this.$user.language;
        this.fetchTags();

    },
    methods: {
        fetchTags () {
            ApiRepository.fetchTags()
                .then((res) => {
                    this.tags = res.data.tags;
                    if (this.tags.length > 0) {
                        this.selected = this.tags[0];
                    }
                    this.getTag();
                }).catch(() => {
                    console.log("ERROR");
                });
        },
        saveTag () {
            const values = {};
            values.descriptionLink = this.descriptionLink;
            values.link = this.link;
            values.videoUrl = this.videoURL;
            ApiRepository.setExtraMessageSystem(this.selected, this.selectedLanguages, values).then((res) => {
                this.$root.$emit('show-snackbar', {message: this.$t('EditableSystemMessages.Save Tag'), color: "success"});
            }).catch((e) => {
                
            });
        },
        getTag () {
            ApiRepository.getExtraMessageSystem(this.selected, this.selectedLanguages).then((res) => {
                const object = JSON.parse(res.data.messageSystem);
                const map =  new Map(object.map(i => [i[0], i[1]]));
                if (map.has('videoUrl')) this.videoURL = map.get('videoUrl');
                if (map.has('link')) this.link = map.get('link');
                if (map.has('descriptionLink')) this.descriptionLink = map.get('descriptionLink');
                this.text = this.$t(this.selected);
                this.textExtra = this.$t(this.selected + 'Extra');
            }).catch((err) => {
                console.log("ERROR GET EXTRA MESSAGE");
            });
        },
        changeUser: function () {
            this.videoURL = '';
            this.link = '';
            this.descriptionLink = '';
            this.getTag();
            this.text = this.$t(this.selected);
            this.textExtra = this.$t(this.selected + 'Extra');
        }
    }
};
</script>

<style scoped>

</style>
